export default __webpack_public_path__ + "static/media/1.94e96026.gif";